import React from 'react';

import { SvgIcon } from '@material-ui/core';

const AutoStoriesIcon = ({ classes, ...props }) => {
  return (
    <SvgIcon classes={classes} {...props}>
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M19 1l-5 5v11l5-4.5V1zM1 6v14.65c0 .25.25.5.5.5.1 0 .15-.05.25-.05C3.1 20.45 5.05 20 6.5 20c1.95 0 4.05.4 5.5 1.5V6c-1.45-1.1-3.55-1.5-5.5-1.5S2.45 4.9 1 6zm22 13.5V6c-.6-.45-1.25-.75-2-1v13.5c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5v2c1.35-.85 3.8-1.5 5.5-1.5 1.65 0 3.35.3 4.75 1.05.1.05.15.05.25.05.25 0 .5-.25.5-.5v-1.1z" />
    </SvgIcon>
  );
};

export default AutoStoriesIcon;
